"use server"

import type { DisplayItem, FormShape } from "../shared/types"
import { buildDisplayModelFromXml } from "./internal/display"

/**
 * Parses QTI XML and builds a display model for rendering.
 * This is a server action - call it from the server to keep XML processing secure.
 */
export async function buildDisplayModel(qtiXml: string): Promise<{
	itemKey: string
	item: DisplayItem
	shape: FormShape
}> {
	return buildDisplayModelFromXml(qtiXml)
}

// Re-export the internal function for direct use
export { buildDisplayModelFromXml }
